import React from 'react';

const DropDownSelect = props => {
    const { labelClass, wrapperClass, label, value, options, loading, defaultOption, onChange } = props;
    const { value: defaultValue, text: defaultText } = defaultOption;
    return (
        <>
            <label className={`${labelClass}`}>{label}</label>
            <div className={`input-wrapper ${wrapperClass}`}>
                <select
                    className="form-control"
                    value={value}
                    onChange={onChange}
                >
                    <option value={defaultValue} key="default">{loading ? 'Loading...' : defaultText || 'Choose Option'}</option>
                    {options?.map(c => {
                        return c.enabled ? <option value={c.id} key={c.id}>{c.name}</option> : null;
                    })}
                </select>
            </div>
        </>
    );
};

export default DropDownSelect;
